var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackingorange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 16.5529C15.8576 16.5529 16.5532 15.8574 16.5532 14.9994C16.5532 14.1414 15.8576 13.4458 14.9996 13.4458C14.1416 13.4458 13.446 14.1414 13.446 14.9994C13.446 15.8574 14.1416 16.5529 14.9996 16.5529Z",
    stroke: "#EC6825",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3845 10.6141C20.3988 11.6286 21.0299 12.9634 21.1704 14.391C21.3109 15.8187 20.952 17.2509 20.1548 18.4436C19.3577 19.6364 18.1717 20.5158 16.7989 20.9321C15.426 21.3484 13.9513 21.2759 12.626 20.7268C11.3007 20.1777 10.2068 19.1861 9.53059 17.9208C8.85442 16.6556 8.63786 15.1951 8.91781 13.7881C9.19775 12.3811 9.95688 11.1147 11.0659 10.2047C12.1748 9.29468 13.565 8.79732 14.9996 8.79736",
    stroke: "#EC6825",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7935 7.96357C24.406 9.74957 25.3561 12.0352 25.4849 14.438C25.6137 16.8408 24.9133 19.2149 23.501 21.163C22.0886 23.1112 20.05 24.5151 17.7263 25.1399C15.4026 25.7647 12.9348 25.5724 10.7359 24.5952C8.53705 23.618 6.74051 21.9152 5.64697 19.7719C4.55343 17.6285 4.22924 15.1745 4.72867 12.8207C5.22809 10.4668 6.52082 8.35596 8.39051 6.84129C10.2602 5.32662 12.5934 4.50009 14.9996 4.5",
    stroke: "#EC6825",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5L15 13.5",
    stroke: "#EC6825",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingorange);
export default __webpack_public_path__ + "static/media/trackingorange.1b7ff6371ab0183dc2b43c9fc6f8b020.svg";
export { ForwardRef as ReactComponent };